import { Component } from '@angular/core';
import { EnvironmentService } from '@methylium/core';
import { EnvironmentFeatures } from '@era/app';
import { DeviceSwappedCurrentActionBarContainerComponent } from '../device-swapped-current-action-bar/device-swapped-current-action-bar.container';

@Component({
  selector: 'era-device-swapped-current',
  templateUrl: './device-swapped-current.component.html',
  styleUrls: ['./device-swapped-current.component.scss'],
  imports: [DeviceSwappedCurrentActionBarContainerComponent],
})
export class DeviceSwappedCurrentComponent {
  public readonly features: EnvironmentFeatures;

  constructor(private readonly environmentService: EnvironmentService) {
    this.features = this.environmentService.environment.features;
  }
}
